const i18n = {
  'modifyPassword': {
    'form': {
      'oldPassword': '目前密碼',
      'password': '新密碼',
      'confirmPassword': '確認新密碼',
      'modifyPassword': '修改密碼',
      'success': '修改密碼成功'
    },
    'error': {
      'wrongPassword': '密碼錯誤',
      'emptyPassword': '密碼為必填',
      'confirmPassword': '兩次輸入的密碼不同',
    }
  }
};
export default i18n;
